import axios from "axios";
import { SearchResponse } from "../types/globalSearch";

const PAGE_SIZE = 100;

export const globalSearchApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: `${process.env.REACT_APP_GLOBAL_SEARCH_SERVICE_HOSTNAME}`,
  withCredentials: true,
});

export const GlobalSearchAPI = {
  async quickSearchResourceItem(companyId: number, resourceSubType: string) {
    // Fetch first page to get total count
    const firstResponse = await globalSearchApi.get(
      `/v2/quicksearch?companyId=${companyId}&term=status:effective&resources=registry-item&resourceSubType=${resourceSubType}&size=${PAGE_SIZE}&page=1`,
    );

    const firstPage = SearchResponse.parse(firstResponse.data);

    if (firstPage.total <= PAGE_SIZE) {
      return firstPage;
    }

    // Fetch remaining pages in parallel
    const totalPages = Math.ceil(firstPage.total / PAGE_SIZE);
    const pageNumbers = Array.from({ length: totalPages - 1 }, (_, i) => i + 2);

    const responses = await Promise.all(
      pageNumbers.map((page) =>
        globalSearchApi.get(
          `/v2/quicksearch?companyId=${companyId}&term=status:effective&resources=registry-item&resourceSubType=${resourceSubType}&size=${PAGE_SIZE}&page=${page}`,
        ),
      ),
    );

    const allResults = [
      ...firstPage.results,
      ...responses.flatMap((res) => SearchResponse.parse(res.data).results),
    ];

    return {
      results: allResults,
      page: 1,
      size: allResults.length,
      total: allResults.length,
    };
  },
};
